import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _0cd96148 = () => interopDefault(import('../../../src/pages/access.vue' /* webpackChunkName: "pages/access" */))
const _197c0a6f = () => interopDefault(import('../../../src/pages/contact/index.vue' /* webpackChunkName: "pages/contact/index" */))
const _0a756c07 = () => interopDefault(import('../../../src/pages/courses/index.vue' /* webpackChunkName: "pages/courses/index" */))
const _363bfe0e = () => interopDefault(import('../../../src/pages/freetrial/index.vue' /* webpackChunkName: "pages/freetrial/index" */))
const _42b5e90c = () => interopDefault(import('../../../src/pages/news/index.vue' /* webpackChunkName: "pages/news/index" */))
const _2a6802ae = () => interopDefault(import('../../../src/pages/phrases/index.vue' /* webpackChunkName: "pages/phrases/index" */))
const _01438996 = () => interopDefault(import('../../../src/pages/teachers.vue' /* webpackChunkName: "pages/teachers" */))
const _078e9ae8 = () => interopDefault(import('../../../src/pages/contact/thankyou.vue' /* webpackChunkName: "pages/contact/thankyou" */))
const _2c580e14 = () => interopDefault(import('../../../src/pages/courses/adults.vue' /* webpackChunkName: "pages/courses/adults" */))
const _65257d48 = () => interopDefault(import('../../../src/pages/courses/kids.vue' /* webpackChunkName: "pages/courses/kids" */))
const _b1a09610 = () => interopDefault(import('../../../src/pages/courses/private.vue' /* webpackChunkName: "pages/courses/private" */))
const _93c8bfc4 = () => interopDefault(import('../../../src/pages/freetrial/thankyou.vue' /* webpackChunkName: "pages/freetrial/thankyou" */))
const _46232b9c = () => interopDefault(import('../../../src/pages/news/_slug.vue' /* webpackChunkName: "pages/news/_slug" */))
const _2dd5453e = () => interopDefault(import('../../../src/pages/phrases/_slug.vue' /* webpackChunkName: "pages/phrases/_slug" */))
const _089784c4 = () => interopDefault(import('../../../src/pages/index.vue' /* webpackChunkName: "pages/index" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/access",
    component: _0cd96148,
    name: "access"
  }, {
    path: "/contact",
    component: _197c0a6f,
    name: "contact"
  }, {
    path: "/courses",
    component: _0a756c07,
    name: "courses"
  }, {
    path: "/freetrial",
    component: _363bfe0e,
    name: "freetrial"
  }, {
    path: "/news",
    component: _42b5e90c,
    name: "news"
  }, {
    path: "/phrases",
    component: _2a6802ae,
    name: "phrases"
  }, {
    path: "/teachers",
    component: _01438996,
    name: "teachers"
  }, {
    path: "/contact/thankyou",
    component: _078e9ae8,
    name: "contact-thankyou"
  }, {
    path: "/courses/adults",
    component: _2c580e14,
    name: "courses-adults"
  }, {
    path: "/courses/kids",
    component: _65257d48,
    name: "courses-kids"
  }, {
    path: "/courses/private",
    component: _b1a09610,
    name: "courses-private"
  }, {
    path: "/freetrial/thankyou",
    component: _93c8bfc4,
    name: "freetrial-thankyou"
  }, {
    path: "/news/:slug",
    component: _46232b9c,
    name: "news-slug"
  }, {
    path: "/phrases/:slug",
    component: _2dd5453e,
    name: "phrases-slug"
  }, {
    path: "/",
    component: _089784c4,
    name: "index"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
